
import { PAGE_TYPE, QUERY_BLOG_PAGE } from "./-index.query";
import { seoMixin, pageMixin } from "~/mixins";
import { getBlogBreadcrumbSchemaScript } from "~/utils/blogs-breadcrumb-schema";

const UID = "inspiration";

export default {
  mixins: [seoMixin, pageMixin],

  async asyncData({ store, app, query: { page = 1, tag }, error } = {}) {
    const { [PAGE_TYPE]: data } = await app.$prismicGql.request({
      query: QUERY_BLOG_PAGE,
      variables: { uid: UID },
    });

    if (!data) {
      return error({
        statusCode: 404,
        message: "Blog list page not found in the app",
      });
    }

    const { data: blogResultData } = await app.$search.blogSearch({
      page,
      tags: tag ? [tag] : [],
      pageSize: store.state.siteConfig.blogsPerPage,
    });

    return {
      blogResultData,
      title: data.title,
      uid: UID,
      pageType: PAGE_TYPE,
      metaTitle: data.metaTitle,
      metaDescription: data.metaDescription,
      metaRobots: data.metaRobots,
      metaFields: { _linkType: data._linkType, _meta: data._meta },
    };
  },

  computed: {
    tagName() {
      return (this.$route.params.tag ?? "").replace(/-/g, " ");
    },
    additionalScripts() {
      return getBlogBreadcrumbSchemaScript({
        baseUrl: this.$config.appEndPoint,
        hid: "blog-list-breadcrumb-schema",
      });
    },
  },

  watchQuery: ["page"],
};
